module.exports = __webpack_public_path__ + "img/ROUND SHADES PURPLE.8981a28.svg";